module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/pleasant/37ea482ca87f600fcb2920fb94533ae0.png";